// checkout page component
import DOMPurify from 'dompurify';
import { useEffect, useRef, useState } from "react";
import ImageWithFallback from "./ui/ImageWithFallback";
import { useCart } from "../context/CartProvider";

const OrganonOrderingCartMyCheckout = () => {
	const { patientResources, setPatientResources, numberOfItems, setNumberOfItems, isItemAddedToCart, setIsItemAddedToCart, isItemChangedInCart, setIsItemChangedInCart, isItemSavedInCart, setIsItemSavedInCart, editItem, updateHeaderCartBtn } = useCart()
	const [isContentLoaded, setIsContentLoaded] = useState(0);
	const [sppinerLoader, setSppinerLoader] = useState(false);
	const [countryCode, setCountryCode] = useState("");
	const [errorsStatusUI, setErrorsStatusUI] = useState({
		errorMsgForUiDisplay: "",
		cartEmpty: false,
		badRequest: false,
		criticalErrorAPIend: false,
	});

	const {
		is_user_logged_in,
		enable_member_gated,
		is_cart_limit_applicable_active_flag,
		flagFieldData,
		lang_cart_limit,
		lang_ci_email,
		lang_first_name,
		lang_last_name,
		lang_ci_phone_number,
		lang_practice_name,
		lang_address,
		lang_appartment,
		lang_suite,
		lang_city,
		lang_province,
		lang_postcode,
		lang_order_checkout,
		lang_edit_item,
		lang_remove_item,
		lang_submit_order_button,
		lang_cart_empty_msg,
		lang_cancel_button,
		lang_terms_conditions_text,
		lang_terms_conditions_title,
		lang_terms_conditions_description,
		lang_title_required_msg,
		lang_ci_title_name,
		lang_first_name_required_msg,
		lang_last_name_required_msg,
		lang_phone_number_required_msg,
		lang_practice_name_required_msg,
		lang_address_required_msg,
		lang_appartment_required_msg,
		lang_suite_required_msg,
		lang_city_required_msg,
		lang_province_required_msg,
		lang_postcode_required_msg,
		lang_critical_error_api_msg,
		lang_something_went_wrong_msg,
		lang_cart_is_empty_msg,
		lang_order_process_msg,
		lang_instruction_msg_1,
		lang_instruction_msg_2,
		lang_cancel_button_redirect_url,
		lang_material_variant,
		lang_material_quantity,
		lang_material_size,
		lang_added_to_cart,
		lang_save_changes,
		lang_saved_changes,
		lang_back_to_orders,
		cart_internal_email,
		cart_country_code,
		template_directory_uri,
		lang_order_summary,
	} = window.ordering_cart_script_checkout;

	const langTermsConditionsTextSanitizedHtml = DOMPurify.sanitize(lang_terms_conditions_text);
	const langTermsConditionsDescriptionSanitizedHtml = DOMPurify.sanitize(lang_terms_conditions_description);
	let flagData = JSON.parse(flagFieldData);
	const titleOptions =
		flagData.titleOptions.length > 0 ? flagData.titleOptions.split(",") : [];

	const [shippingAddress, setShippingAddress] = useState({
		orderNo: '',
		title: titleOptions.length > 0 ? titleOptions[0] : "",
		titleOptions: titleOptions,
		email: '',
		firstName: '',
		lastName: '',
		phoneNumber: '',
		practiceName: '',
		address: '',
		appartment: '',
		suite: '',
		city: '',
		province: '',
		postcode: '',
		uuid: '',
		countryCode: '',
		internal_email: '',
		no_of_products: 0,
		terms_condition_check: false,
		orderItems: []
	});

	const [formErrors, setFormErrors] = useState({});
	const shippingAddressRef = useRef(shippingAddress);
	// Remove order confirmation data from localStorage when component mounts
	useEffect(() => {
		localStorage.removeItem('orderconfirmationdatafromcheckout')
	}, [])

	useEffect(() => {
		// Update ref when state changes
		shippingAddressRef.current = shippingAddress;
	}, [shippingAddress]);

	const cartItemsRef = useRef(null);
	let userProfileData = JSON.parse(localStorage.getItem("janrainCaptureProfileData"));
	
	/**
	 * Effect to initialize the shipping address and cart items
	 * This effect runs when the component mounts and sets the initial state.
	 */
	useEffect(() => {
		let shippingAddressUpdated = { ...shippingAddress };
		const checkoutblock = document.getElementById("checkoutblock");
		const item = document.getElementById("carthiddenInfo");
		const cartItems = localStorage.getItem("cartItems");
		if (userProfileData !== null) {
			shippingAddressUpdated.email = userProfileData.email;
			shippingAddressUpdated.uuid = userProfileData.uuid;
		}
		const code = item?.getAttribute("data-countryCode") || "";
		setCountryCode(code);
		if (code === "AU" && userProfileData?.address) {
			shippingAddressUpdated.firstName = userProfileData.givenName;
			shippingAddressUpdated.lastName = userProfileData.familyName;
			shippingAddressUpdated.phoneNumber = userProfileData.address.phone;
			shippingAddressUpdated.address = userProfileData.address.addressLine1;
			shippingAddressUpdated.appartment = userProfileData.address.addressLine2;
			shippingAddressUpdated.city = userProfileData.address.district;
			shippingAddressUpdated.province = userProfileData.address.state;
			shippingAddressUpdated.postcode = userProfileData.address.postalCode;
		}
		if (cartItems) {
			const parsed = JSON.parse(cartItems);
			cartItemsRef.current = parsed;
			setPatientResources(parsed);
			setNumberOfItems(parsed.length);
			shippingAddressUpdated.orderItems = cartItems;
			setIsContentLoaded(1);
			if (checkoutblock) checkoutblock.style.display = "block";
		}
		if (item) {
			const code = item.getAttribute("data-countryCode");
			const internal_email = item.getAttribute("data-internal_email");
			if (code) shippingAddressUpdated.countryCode = code;
			if (internal_email) shippingAddressUpdated.internal_email = internal_email;
		}
		setShippingAddress(shippingAddressUpdated);
	}, []);

	// resetting ui errors
	const resetUiErrors = () => {
		setErrorsStatusUI({
			errorMsgForUiDisplay: "",
			cartEmpty: false,
			badRequest: false,
			criticalErrorAPIend: false,
		});
	};

	// get current date and time in a specific format
	const getCurrentDateTime = () => {
		let today = new Date();
		const dd = String(today.getDate()).padStart(2, "0");
		const mm = String(today.getMonth() + 1).padStart(2, "0");
		const yyyy = today.getFullYear();
		const Hr = today.getHours();
		const Min = today.getMinutes();
		const Sec = today.getSeconds();
		return (today = yyyy + mm + dd + Hr + Min + Sec);
	};

	/**
	 * Converts specific flags in the cart items to string format.
	 * The cart items to process.
	 * An array of processed cart items with flags converted to strings.
	 */
	const convertFlagsIntoString = (cartItems) => {
		const KeyOfFlagsForConvertIntoSTring = [
			"enable_download_only",
			"is_material_variant",
			"is_material_size",
			"is_associated_product",
			"is_material_category_indication",
			"is_material_format",
			"is_material_hidden_price",
		];
		const KeyForString = ["material_hidden_price", "is_featured_product_order"];
		if (Array.isArray(cartItems) && cartItems.length > 0) {
			const temp = cartItems.map((item) => {
				const tempObj = {};
				Object.keys(item).forEach((key) => {
					let ObjecValue = item[key];
					if (KeyOfFlagsForConvertIntoSTring.includes(key)) {
						ObjecValue = ObjecValue === false ? "0" : "1";
					}
					if (KeyForString.includes(key)) {
						ObjecValue = ObjecValue.toString();
					}
					if (key === "thumbnail_url") {
						ObjecValue = false; // per MuleSoft API requirement
					}
					tempObj[key] = ObjecValue;
				});
				return tempObj;
			});
			return temp;
		}
		return [];
	};

	const showLoadderScreen = () => {
		$("#cartorderProModel").modal("show");
	};

	const hideLoadderScreen = () => {
		setTimeout(() => {
			$("#cartorderProModel").modal("hide");
			window.scrollTo(0, 100);
		}, 2000);
	};

	/**
	 * Submits the shipping form.
	 * This function gathers the shipping address and cart items,
	 * validates the data, and sends it to the server.
	 */
	const submitShippingForm = () => {
		showLoadderScreen();
		resetUiErrors();
		const cartItemsStr = localStorage.getItem("cartItems");
		const cartItems = cartItemsStr ? JSON.parse(cartItemsStr) : [];
		// since the product type is not mendetory in patient resource but we need to sent it API submittion hence we are checking 
		cartItems.forEach(item => {
			if (typeof item.product_type === 'object' && item.product_type !== null || item.product_type === 'select_type') {
				item.product_type = '';
			}
		});

		if (cartItems && cartItems.length > 0) {
			const updatedAddress = { ...shippingAddress };
			updatedAddress.no_of_products = cartItems.length;
			updatedAddress.orderItems = convertFlagsIntoString(cartItems);
			updatedAddress.orderNo = getCurrentDateTime();
			const data = { ...updatedAddress };
			if (data && data.title !== "") {
				data.lastName = `${data.title} ${data.lastName}`;
			}
			const newData = { ...updatedAddress }
			if (isOrderDataValid(data)) {
				setSppinerLoader(true);
				fetch(front_end_ajax_obj.siteurl + "checkout/v1/cartordersubmit", {
					method: "POST",
					headers: {
						"Content-Type": "application/json; charset=UTF-8",
						'Authorization': 'Basic b3JnYW5vbnBybzpPcmdhbm9ucHIw' // Basic auth for popup organonpro website
					},
					body: JSON.stringify(newData),
				})
					.then((res) =>
						res.json().then((json) => ({ status: res.status, data: json })),
					)
					.then(({ status, data }) => {
						setSppinerLoader(false);
						if (status === 200) {
							if (data.status === "201") {
								localStorage.setItem(
									"orderconfirmationdatafromcheckout",
									JSON.stringify(newData),
								);
								localStorage.setItem("cartItems", JSON.stringify([]));

								const orderedItems = cartItems.map((item) => ({
									item_name: item.post_title,
									item_id: item.material_code,
									item_size: item.order_size,
									item_variant: item.order_variant,
									quantity: item.order_quantity,
								}));
								window.dataLayer = window.dataLayer || [];
								window.dataLayer.push({
									event: "purchase",
									ecommerce: {
										transaction_id: newData.orderNo,
										items: orderedItems,
									},
								});
								setTimeout(() => {
									const sanitizedUrl = new URL(DOMPurify.sanitize(site_url_obj.siteurl + "/orderconfirmation"), window.location.origin).href;
									window.location.href = sanitizedUrl;
								}, 500);
							} else if (data.status === "400") {
								setErrorsStatusUI((prev) => ({ ...prev, badRequest: true }));
								hideLoadderScreen();
							} else {
								setErrorsStatusUI((prev) => ({
									...prev,
									criticalErrorAPIend: true,
								}));
								hideLoadderScreen();
							}
						} else {
							setErrorsStatusUI((prev) => ({
								...prev,
								criticalErrorAPIend: true,
							}));
							hideLoadderScreen();
						}
					})
					.catch(() => {
						setSppinerLoader(false);
						setErrorsStatusUI((prev) => ({
							...prev,
							criticalErrorAPIend: true,
						}));
						hideLoadderScreen();
					});
			} else {
				setSppinerLoader(false);
				setErrorsStatusUI((prev) => ({ ...prev, badRequest: true }));
			}
		} else {
			setErrorsStatusUI((prev) => ({ ...prev, cartEmpty: true }));
		}

		if (errorsStatusUI.errorMsgForUiDisplay !== "") {
			hideLoadderScreen();
		}
	};

	/**
	 * Validates the order data.
	 * The order data to validate.
	 * true if the order data is valid, false otherwise.
	 */
	const isOrderDataValid = (orderData) => {
		let isError = false;
		if (orderData !== null) {
			if (orderData.no_of_products === 0) isError = true;
			if (orderData.internal_email === "") isError = true;
			if (orderData.orderItems.length === 0) isError = true;
			return !isError;
		}
		return false;
	};

	/**
	 * Removes an item from the cart.
	 * The ID of the product to remove.
	 */
	const remove = (productid) => {
		const cartItems = localStorage.getItem("cartItems");
		if (cartItems !== null && cartItems !== undefined) {
			let resources = JSON.parse(cartItems);
			let removedItem = {};

			resources.forEach((item) => {
				if (item.ID === productid) {
					removedItem = item;
				}
			});
			resources = resources.filter((item) => item.ID !== productid);
			setPatientResources(resources); // set state
			setNumberOfItems(resources.length); // update count
			localStorage.setItem("cartItems", JSON.stringify(resources));
			const testBtn = document.getElementById("orderingCartAddItemTestBtn");
			if (testBtn !== undefined && testBtn !== null) {
				testBtn.click();
			}
			updateHeaderCartBtn()
			// Google Analytics event
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: "remove_from_cart",
				ecommerce: {
					items: [
						{
							item_name: removedItem.post_title,
							item_id: removedItem.material_code,
							item_size: removedItem.order_size,
							item_variant: removedItem.order_variant,
							quantity: removedItem.order_quantity,
						},
					],
				},
			});
		}
	};

	/**
	 * Refreshes the cart items and updates the state.
	 */
	const refresh = () => {
		const cartItemsStr = localStorage.getItem("cartItems");
		const cartItems = cartItemsStr ? JSON.parse(cartItemsStr) : [];
		setPatientResources(cartItems);
		setNumberOfItems(cartItems.length);
		localStorage.setItem("cartItems", JSON.stringify(cartItems));
	};

	/**
	 * Handles changes to the shipping address fields.
	 */
	const handleChange = (e) => {
		const { name, value } = e.target;
		setShippingAddress({ ...shippingAddress, [name]: value });
	};

	/**
	 * Handles changes to the shipping address fields.
	 */
	const handleCheckboxChange = (e) => {
		setShippingAddress({
			...shippingAddress,
			[e.target.name]: e.target.checked,
		});
	};

	/**
	 * Handles form submission.
	 */
	const handleSubmit = (e) => {
		e.preventDefault();
		if (validateForm()) {
			submitShippingForm();
		}
	};

	/**
	 * Validates the entire shipping form.
	 * true if the form is valid, false otherwise.
	 */
	const validateForm = () => {
		const errors = {};

		// Email
		if (flagData.email && !shippingAddress.email) {
			errors.email = lang_email_required_msg;
		}

		// Title
		if (
			flagData.titleFiled &&
			flagData.titelRequiredFlag &&
			!shippingAddress.title
		) {
			errors.title = lang_title_required_msg;
		}

		// First Name
		if (flagData.firstNameRequiredFlag && !shippingAddress.firstName) {
			errors.firstName = lang_first_name_required_msg;
		}

		// Last Name
		if (
			flagData.lastName &&
			flagData.lastNameRequiredFlag &&
			!shippingAddress.lastName
		) {
			errors.lastName = lang_last_name_required_msg;
		}

		// Phone Number
		if (
			flagData.phoneNumber &&
			flagData.phoneNumberRequiredFlag &&
			!shippingAddress.phoneNumber
		) {
			errors.phoneNumber = lang_phone_number_required_msg;
		}

		// Practice Name
		if (
			flagData.practiceName &&
			flagData.practiceNameRequiredFlag &&
			!shippingAddress.practiceName
		) {
			errors.practiceName = lang_practice_name_required_msg;
		}

		// Address
		if (
			flagData.address &&
			flagData.addressRequiredFlag &&
			!shippingAddress.address
		) {
			errors.address = lang_address_required_msg;
		}

		// Appartment
		if (
			flagData.appartment &&
			flagData.appartmentRequiredFlag &&
			!shippingAddress.appartment
		) {
			errors.appartment = lang_appartment_required_msg;
		}

		// Suite
		if (
			flagData.suite &&
			flagData.suiteRequiredFlag &&
			!shippingAddress.suite
		) {
			errors.suite = lang_suite_required_msg;
		}

		// City
		if (flagData.city && flagData.cityRequiredFlag && !shippingAddress.city) {
			errors.city = lang_city_required_msg;
		}

		// Province
		if (
			flagData.province &&
			flagData.provinceRequiredFlag &&
			!shippingAddress.province
		) {
			errors.province = lang_province_required_msg;
		}

		// Postcode
		if (
			flagData.postcode &&
			flagData.postcodeRequiredFlag &&
			!shippingAddress.postcode
		) {
			errors.postcode = lang_postcode_required_msg;
		}

		// Terms and Conditions
		if (
			flagData.termsandconditions &&
			flagData.termsofusecheckboxRequiredFlag &&
			shippingAddress.terms_condition_check === false
		) {
			errors.terms_condition_check = lang_terms_conditions_required;
		}

		setFormErrors(errors);
		return Object.keys(errors).length === 0;
	};

	/**
	 * Validates a single form field.
	 */
	const validateField = (fieldName, value) => {
		const errors = { ...formErrors };
		switch (fieldName) {
			case 'email':
				if (flagData.email && !value) {
					errors.email = lang_email_required_msg;
				} else {
					delete errors.email;
				}
				break;

			case 'title':
				if (flagData.titleFiled && flagData.titelRequiredFlag && !value) {
					errors.title = lang_title_required_msg;
				} else {
					delete errors.title;
				}
				break;

			case 'firstName':
				if (flagData.firstNameRequiredFlag && !value) {
					errors.firstName = lang_first_name_required_msg;
				} else {
					delete errors.firstName;
				}
				break;

			case 'lastName':
				if (flagData.lastName && flagData.lastNameRequiredFlag && !value) {
					errors.lastName = lang_last_name_required_msg;
				} else {
					delete errors.lastName;
				}
				break;

			case 'phoneNumber':
				if (flagData.phoneNumber && flagData.phoneNumberRequiredFlag && !value) {
					errors.phoneNumber = lang_phone_number_required_msg;
				} else {
					delete errors.phoneNumber;
				}
				break;

			case 'practiceName':
				if (flagData.practiceName && flagData.practiceNameRequiredFlag && !value) {
					errors.practiceName = lang_practice_name_required_msg;
				} else {
					delete errors.practiceName;
				}
				break;

			case 'address':
				if (flagData.address && flagData.addressRequiredFlag && !value) {
					errors.address = lang_address_required_msg;
				} else {
					delete errors.address;
				}
				break;

			case 'appartment':
				if (flagData.appartment && flagData.appartmentRequiredFlag && !value) {
					errors.appartment = lang_appartment_required_msg;
				} else {
					delete errors.appartment;
				}
				break;

			case 'suite':
				if (flagData.suite && flagData.suiteRequiredFlag && !value) {
					errors.suite = lang_suite_required_msg;
				} else {
					delete errors.suite;
				}
				break;

			case 'city':
				if (flagData.city && flagData.cityRequiredFlag && !value) {
					errors.city = lang_city_required_msg;
				} else {
					delete errors.city;
				}
				break;

			case 'province':
				if (flagData.province && flagData.provinceRequiredFlag && !value) {
					errors.province = lang_province_required_msg;
				} else {
					delete errors.province;
				}
				break;

			case 'postcode':
				if (flagData.postcode && flagData.postcodeRequiredFlag && !value) {
					errors.postcode = lang_postcode_required_msg;
				} else {
					delete errors.postcode;
				}
				break;

			default:
				break;
		}
		setFormErrors(errors);
	};

	/**
	 * Validates the entire form.
	 * Returns true if the form is valid, false otherwise.
	 */
	const validForm = () => {
		const cartItemsStr = localStorage.getItem("cartItems");
		const resources = cartItemsStr ? JSON.parse(cartItemsStr) : [];
		// Inline validation logic (copied from validateForm)
		let hasErrors = false;
		if (flagData.email && !shippingAddress.email) hasErrors = true;
		if (flagData.titleFiled && flagData.titelRequiredFlag && !shippingAddress.title) hasErrors = true;
		if (flagData.firstNameRequiredFlag && !shippingAddress.firstName) hasErrors = true;
		if (flagData.lastName && flagData.lastNameRequiredFlag && !shippingAddress.lastName) hasErrors = true;
		if (flagData.phoneNumber && flagData.phoneNumberRequiredFlag && !shippingAddress.phoneNumber) hasErrors = true;
		if (flagData.practiceName && flagData.practiceNameRequiredFlag && !shippingAddress.practiceName) hasErrors = true;
		if (flagData.address && flagData.addressRequiredFlag && !shippingAddress.address) hasErrors = true;
		if (flagData.appartment && flagData.appartmentRequiredFlag && !shippingAddress.appartment) hasErrors = true;
		if (flagData.suite && flagData.suiteRequiredFlag && !shippingAddress.suite) hasErrors = true;
		if (flagData.city && flagData.cityRequiredFlag && !shippingAddress.city) hasErrors = true;
		if (flagData.province && flagData.provinceRequiredFlag && !shippingAddress.province) hasErrors = true;
		if (flagData.postcode && flagData.postcodeRequiredFlag && !shippingAddress.postcode) hasErrors = true;
		if (
			flagData.termsandconditions &&
			flagData.termsofusecheckboxRequiredFlag &&
			shippingAddress.terms_condition_check === false
		) {
			hasErrors = true;
		}
		return hasErrors || resources.length === 0;
	};

	return (
		<div>
			{!isContentLoaded && (
				<div className="product-container container text-center">
					<img
						src={`${template_directory_uri}/assets/images/spinner.gif`}
						alt="Loading spinner"
					/>
				</div>
			)}
			<div
				className="checkoutContainer container"
				id="checkoutblock"
				style={{ display: "none" }}
			>
				<div className="refreshsummary">
					<button
						className="btn btn-theme ordering-summary-referesh-btn"
						onClick={refresh}
						type="button"
						id="orderingSummaryRefreshBtn"
					>
						Refresh
					</button>
				</div>
				{errorsStatusUI.cartEmpty && (
					<div className="alert alert-info alert-dismissible">
						{lang_cart_is_empty_msg}
					</div>
				)}
				{errorsStatusUI.badRequest && (
					<div className="alert alert-warning alert-dismissible">
						{lang_something_went_wrong_msg}
					</div>
				)}
				{errorsStatusUI.criticalErrorAPIend && (
					<div className="alert alert-danger alert-dismissible">
						{lang_critical_error_api_msg}
					</div>
				)}
				<div className="container">
					<div className="row checkoutpagerow">
						<div className="checkoutPageFormContainer">
							{/* Checkout Title */}
							<p className="ordercheckouttitle">{lang_order_checkout}</p>
							{/* Accordion Start */}
							<div
								className="accordion accordion-flush mobileordersummary"
								id="accordionFlushSummary"
							>
								<button
									className="accordion-button collapsed"
									type="button"
									data-bs-toggle="collapse"
									data-bs-target="#flush-collapseOne"
									aria-expanded="false"
									aria-controls="flush-collapseOne"
								>
									<p className="ordersummaryttitle checkoutordertitle">
										{lang_order_summary}
									</p>
								</button>
								{/* Order Summary */}
								<div className="orderSummaryPagecheckoutorderpage mobileordersummerycontent row container-fluid container">
									{patientResources.length > 0 ? (
										patientResources.map((patientResource, index) => (
											<div key={index} className="checkoutCardscheckout">
												<div className="checkoutcardBody checkoutbody">
													<ImageWithFallback src={patientResource.material_image}
														fallback={`${template_directory_uri}/assets/images/no_preview.png`}
														alt={patientResource.post_title} />
													<div className="checkoutcardBodyContent checkoutorderbody flex-grow-1">
														<h1>{patientResource.post_title}</h1>
														{/* Order Variant and Size */}
														{patientResource.order_size &&
															patientResource.order_variant && (
																<p className="checkoutvarient">
																	{patientResource.order_variant},{" "}
																	{patientResource.order_size}
																</p>
															)}
														{patientResource.order_variant &&
															!patientResource.order_size && (
																<p className="checkoutvarient">
																	{patientResource.order_variant}
																</p>
															)}
														{!patientResource.order_variant &&
															patientResource.order_size && (
																<p className="checkoutvarient">
																	{patientResource.order_size}
																</p>
															)}
														{/* Edit and Remove Buttons */}
														<div className="checkoutcardFooter">
															<a
																href="#"
																onClick={() => editItem(patientResource)} // editItem function needs to be passed or implemented
																className="checkoutCartEditButton"
																data-bs-toggle="offcanvas"
																data-bs-target="#orderingCartEditItemDivReact"
															>
																{lang_edit_item}
															</a>
															<a
																href="#"
																onClick={() => remove(patientResource.ID)} // remove function needs to be passed or implemented
																className="checkoutCartRemoveButton"
															>
																{lang_remove_item}
															</a>
														</div>
													</div>
													{/* Order Quantity */}
													<p className="checkoutItemQuantity checkoutquantity">
														x{patientResource.order_quantity}
													</p>
												</div>
											</div>
										))
									) : (
										<div>
											<p>{lang_cart_empty_msg}</p>
										</div>
									)}
								</div>
							</div>
							{/* Accordion End */}

							<form
								onSubmit={handleSubmit}
								id="checkoutpageform"
								role="form"
								className="capture_form capture_preregForm checkoutpageForm"
								noValidate
							>
								{/* Email */}
								{flagData.email && (
									<div className="form-group">
										<label htmlFor="email" className="emaillabeltext">
											{lang_ci_email}
											<span className="requiredStar">*</span>
										</label>
										<input
											id="email"
											name="email"
											type="email"
											value={shippingAddress.email}
											onChange={handleChange}
											className="input-group capture_required capture_text_input"
											readOnly
										/>
										{formErrors.email && (
											<div className="ng-error">{formErrors.email}</div>
										)}
									</div>
								)}

								{/* Title */}
								{flagData.titleFiled && (
									<div className="form-group">
										<label htmlFor="title" className="emaillabeltext">
											{lang_ci_title_name}
											{flagData.titelRequiredFlag && (
												<span className="requiredStar">*</span>
											)}
										</label>
										<select
											name="title"
											value={shippingAddress.title}
											onChange={handleChange}
											className="form-control checkoutTitleSelect input-group capture_required capture_text_input"
											required={flagData.titelRequiredFlag}
											onBlur={(e) => validateField('title', e.target.value)}
										>
											{shippingAddress.titleOptions &&
												shippingAddress.titleOptions.map((option, index) => (
													<option key={index} value={option}>
														{option}
													</option>
												))}
										</select>
										{formErrors.title && (
											<div className="ng-error">{formErrors.title}</div>
										)}
									</div>
								)}

								{/* First Name */}
								<div className="form-group">
									<label htmlFor="firstName" className="emaillabeltext">
										{lang_first_name}
										{flagData.firstNameRequiredFlag && (
											<span className="requiredStar">*</span>
										)}
									</label>
									<input
										id="firstName"
										name="firstName"
										type="text"
										value={shippingAddress.firstName}
										onChange={handleChange}
										className={`input-group capture_required capture_text_input ${formErrors.firstName ? "redErrorBorder" : ""
											}`}
										required={flagData.firstNameRequiredFlag}
										onBlur={(e) => validateField('firstName', e.target.value)}
									/>
									{formErrors.firstName && (
										<div className="ng-error">{formErrors.firstName}</div>
									)}
								</div>

								{/* Last Name */}
								{flagData.lastName && (
									<div className="form-group">
										<label htmlFor="lastName" className="emaillabeltext">
											{lang_last_name}
											{flagData.lastNameRequiredFlag && (
												<span className="requiredStar">*</span>
											)}
										</label>
										<input
											id="lastName"
											name="lastName"
											type="text"
											value={shippingAddress.lastName}
											onChange={handleChange}
											className={`input-group capture_required capture_text_input ${formErrors.lastName ? "redErrorBorder" : ""
												}`}
											required={flagData.lastNameRequiredFlag}
											onBlur={(e) => validateField('lastName', e.target.value)}
										/>
										{formErrors.lastName && (
											<div className="ng-error">{formErrors.lastName}</div>
										)}
									</div>
								)}

								{/* Phone Number */}
								{flagData.phoneNumber && (
									<div className="form-group">
										<label htmlFor="phoneNumber" className="emaillabeltext">
											{lang_ci_phone_number}
											{flagData.phoneNumberRequiredFlag && (
												<span className="requiredStar">*</span>
											)}
										</label>
										<input
											id="phoneNumber"
											name="phoneNumber"
											type="text"
											value={shippingAddress.phoneNumber}
											onChange={handleChange}
											className={`input-group capture_required capture_text_input ${formErrors.phoneNumber ? "redErrorBorder" : ""
												}`}
											required={flagData.phoneNumberRequiredFlag}
											onBlur={(e) => validateField('phoneNumber', e.target.value)}
										/>
										{formErrors.phoneNumber && (
											<div className="ng-error">{formErrors.phoneNumber}</div>
										)}
									</div>
								)}

								{flagData.practiceName && (
									<div className="form-group">
										<label htmlFor="practiceName" className="emaillabeltext">
											{lang_practice_name}
											{flagData.practiceNameRequiredFlag && (
												<span className="requiredStar">*</span>
											)}
										</label>
										<input
											id="practiceName"
											name="practiceName"
											type="text"
											value={shippingAddress.practiceName}
											onChange={handleChange}
											className={`input-group capture_required capture_text_input ${formErrors.practiceName ? "redErrorBorder" : ""
												}`}
											required={flagData.practiceNameRequiredFlag}
											autoComplete="off"
											onBlur={(e) => validateField('practiceName', e.target.value)}
										/>
										{formErrors.practiceName && (
											<div className="ng-error">{formErrors.practiceName}</div>
										)}
									</div>
								)}

								{flagData.address && (
									<div className="form-group">
										<label htmlFor="address" className="emaillabeltext">
											{lang_address}
											{flagData.addressRequiredFlag && (
												<span className="requiredStar">*</span>
											)}
										</label>
										<input
											id="address"
											name="address"
											type="text"
											value={shippingAddress.address}
											onChange={handleChange}
											className={`input-group capture_required capture_text_input ${formErrors.address ? "redErrorBorder" : ""
												}`}
											required={flagData.addressRequiredFlag}
											autoComplete="off"
											onBlur={(e) => validateField('address', e.target.value)}
										/>
										{formErrors.address && (
											<div className="ng-error">{formErrors.address}</div>
										)}
									</div>
								)}

								{flagData.appartment && (
									<div className="form-group">
										<label htmlFor="appartment" className="emaillabeltext">
											{lang_appartment}
											{flagData.appartmentRequiredFlag && (
												<span className="requiredStar">*</span>
											)}
										</label>
										<input
											id="appartment"
											name="appartment"
											type="text"
											value={shippingAddress.appartment}
											onChange={handleChange}
											className={`input-group capture_required capture_text_input ${formErrors.appartment ? "redErrorBorder" : ""
												}`}
											required={flagData.appartmentRequiredFlag}
											autoComplete="off"
											onBlur={(e) => validateField('appartment', e.target.value)}
										/>
										{formErrors.appartment && (
											<div className="ng-error">{formErrors.appartment}</div>
										)}
									</div>
								)}

								{flagData.suite && (
									<div className="form-group">
										<label htmlFor="suite" className="emaillabeltext">
											{lang_suite}
											{flagData.suiteRequiredFlag && (
												<span className="requiredStar">*</span>
											)}
										</label>
										<input
											id="suite"
											name="suite"
											type="text"
											value={shippingAddress.suite}
											onChange={handleChange}
											className={`input-group capture_required capture_text_input ${formErrors.suite ? "redErrorBorder" : ""
												}`}
											required={flagData.suiteRequiredFlag}
											autoComplete="off"
											onBlur={(e) => validateField('suite', e.target.value)}
										/>
										{formErrors.suite && (
											<div className="ng-error">{formErrors.suite}</div>
										)}
									</div>
								)}

								{flagData.city && (
									<div className="form-group">
										<label htmlFor="city" className="emaillabeltext">
											{lang_city}
											{flagData.cityRequiredFlag && (
												<span className="requiredStar">*</span>
											)}
										</label>
										<input
											id="city"
											name="city"
											type="text"
											value={shippingAddress.city}
											onChange={handleChange}
											className={`input-group capture_required capture_text_input ${formErrors.city ? "redErrorBorder" : ""
												}`}
											required={flagData.cityRequiredFlag}
											autoComplete="off"
											onBlur={(e) => validateField('city', e.target.value)}
										/>
										{formErrors.city && (
											<div className="ng-error">{formErrors.city}</div>
										)}
									</div>
								)}

								{flagData.province && (
									<div className="form-group">
										<label htmlFor="province" className="emaillabeltext">
											{lang_province}
											{flagData.provinceRequiredFlag && (
												<span className="requiredStar">*</span>
											)}
										</label>
										<input
											id="province"
											name="province"
											type="text"
											value={shippingAddress.province}
											onChange={handleChange}
											className={`input-group capture_required capture_text_input ${formErrors.province ? "redErrorBorder" : ""
												}`}
											required={flagData.provinceRequiredFlag}
											autoComplete="off"
											onBlur={(e) => validateField('province', e.target.value)}
										/>
										{formErrors.province && (
											<div className="ng-error">{formErrors.province}</div>
										)}
									</div>
								)}

								{flagData.postcode && (
									<div className="form-group">
										<label htmlFor="postcode" className="emaillabeltext">
											{lang_postcode}
											{flagData.postcodeRequiredFlag && (
												<span className="requiredStar">*</span>
											)}
										</label>
										<input
											id="postcode"
											name="postcode"
											type="text"
											value={shippingAddress.postcode}
											onChange={handleChange}
											className={`input-group capture_required capture_text_input ${formErrors.postcode ? "redErrorBorder" : ""
												}`}
											required={flagData.postcodeRequiredFlag}
											autoComplete="off"
											onBlur={(e) => validateField('postcode', e.target.value)}
										/>
										{formErrors.postcode && (
											<div className="ng-error">{formErrors.postcode}</div>
										)}
									</div>
								)}

								<div
									className="form-group"
									data-is_user_logged_in={is_user_logged_in}
									data-enable_member_gated={enable_member_gated}
									data-countrycode={cart_country_code}
									id="carthiddenInfo"
									data-internal_email={cart_internal_email}
								>
									<input type="hidden" value={shippingAddress.uuid || ""} />
									<input type="hidden" value={cart_country_code} />
									<input type="hidden" value={cart_internal_email} />
									<input
										type="hidden"
										value={shippingAddress.no_of_products || ""}
									/>
								</div>

								{/* Terms and Conditions */}
								{flagData.termsandconditions && (
									<div id="capture-checkout-acceptTermsofUse">
										{flagData.termsofusecheckboxRequiredFlag && (
											<>
												<input
													type="checkbox"
													id="acceptTermsofUse"
													name="terms_condition_check"
													checked={DOMPurify.sanitize(shippingAddress.terms_condition_check)}
													onChange={handleCheckboxChange}
													data-xyz={DOMPurify.sanitize(shippingAddress.terms_condition_check)}
													required
												/>
												<label htmlFor="acceptTermsofUse" dangerouslySetInnerHTML={{ __html: langTermsConditionsTextSanitizedHtml }}></label>
												<h4 className="termsofusetitle">
													{lang_terms_conditions_title}
												</h4>
											</>
										)}

										<p dangerouslySetInnerHTML={{ __html: langTermsConditionsDescriptionSanitizedHtml }}></p>
									</div>
								)}

								{/* Submit Button */}
								<div className="buttonCheckoutpage">
									<a
										className="cancelbuttoncheckoutPage"
										href={lang_cancel_button_redirect_url}
									>
										{lang_cancel_button}
									</a>
									<input
										value={lang_submit_order_button}
										disabled={validForm()}
										type="submit"
										className="capture_btn capture_primary"
										id="checkoutSubmitbutton"
									/>
								</div>
							</form>
						</div>

						<div className="orderSummaryPagecheckoutorderpage desktopordersummerycontent">
							<p className="ordersummaryttitle checkoutordertitle">
								{lang_order_summary}
							</p>

							{patientResources && patientResources.length > 0 ? (
								patientResources.map((patientResource, index) => (
									<div key={index} className="checkoutCardscheckout">
										<div className="checkoutcardBody checkoutbody">
											<ImageWithFallback src={patientResource.material_image}
												fallback={`${template_directory_uri}/assets/images/no_preview.png`}
												alt={patientResource.post_title} />
											<div className="checkoutcardBodyContent checkoutorderbody flex-grow-1">
												<h1>{patientResource.post_title}</h1>

												{/* Conditional variant and size display */}
												{patientResource.order_variant &&
													patientResource.order_size && (
														<p className="checkoutvarient">
															{patientResource.order_variant},{" "}
															{patientResource.order_size}
														</p>
													)}
												{patientResource.order_variant &&
													!patientResource.order_size && (
														<p className="checkoutvarient">
															{patientResource.order_variant}
														</p>
													)}
												{!patientResource.order_variant &&
													patientResource.order_size && (
														<p className="checkoutvarient">
															{patientResource.order_size}
														</p>
													)}

												{/* Edit / Remove actions */}
												<div className="checkoutcardFooter">
													<a
														href="#"
														className="checkoutCartEditButton"
														data-bs-toggle="offcanvas"
														data-bs-target="#orderingCartEditItemDivReact"
														onClick={(e) => {
															e.preventDefault();
															editItem(patientResource);
														}}
													>
														{lang_edit_item}
													</a>
													<a
														href="#"
														className="checkoutCartRemoveButton"
														onClick={(e) => {
															e.preventDefault();
															remove(patientResource.ID);
														}}
													>
														{lang_remove_item}
													</a>
												</div>
											</div>

											<p className="checkoutItemQuantity checkoutquantity">
												x{patientResource.order_quantity}
											</p>
										</div>
									</div>
								))
							) : (
								<div>
									<p>{lang_cart_empty_msg}</p>
								</div>
							)}
						</div>
					</div>
				</div>

				<div
					className="modal fade processingCart"
					tabIndex="-1"
					role="dialog"
					id="cartorderProModel"
					aria-labelledby="exampleModalCenterTitle"
					aria-hidden="true"
				>
					<div
						className="modal-dialog modal-dialog-centered modal-lg"
						data-backdrop="static"
						role="document"
					>
						<div className="modal-content">
							<div className="modal-body">
								<div className="product-container container text-center">
									<img
										src={`${template_directory_uri}/assets/images/spinner.gif`}
									/>
									<br />
									<div>
										<p id="cartorderprocessMsg1">{lang_order_process_msg}</p>
										<p id="cartorderprocessMsg2">
											{lang_instruction_msg_1}{" "}
											<span className="cartoderRefreshlink">
												{lang_instruction_msg_2}
											</span>
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default OrganonOrderingCartMyCheckout;